import { APP_LK_EMPLOYEE_HOST, APP_LK_ENV, EStages, APP_LK_STAGE } from './app';

import { BannersSkeleton } from ':components/Dashboard/Skeletons/BannersSkeleton';
import { DepartmentSkeleton } from ':components/Dashboard/Skeletons/DepartmentSkeleton';
import { UserInfoSkeleton } from ':components/Dashboard/Skeletons/UserInfoSkeleton';
import { WidgetsData } from ':types';

const developList =
  APP_LK_ENV !== 'production'
    ? sessionStorage.getItem('develop/widgets')
    : null;

const developData: WidgetsData[] = developList ? JSON.parse(developList) : [];

export const preloads = [APP_LK_EMPLOYEE_HOST];

export const containersConfig = [
  {
    id: 1,
    name: 'user',
    order: 1,
    width_large: 12,
    width_medium: 12,
    width_small: 12,
  },
  {
    id: 2,
    name: 'banners',
    order: 2,
    width_large: 12,
    width_medium: 12,
    width_small: 12,
  },
  {
    id: 3,
    name: 'departament',
    order: 3,
    width_large: 4,
    width_medium: 12,
    width_small: 12,
  },
];

const testOnlyWidgets: WidgetsData[] = [EStages.production].includes(
  APP_LK_STAGE
)
  ? []
  : [];

export const widgetsConfig: WidgetsData[] = [
  {
    id: 1,
    host: APP_LK_EMPLOYEE_HOST,
    name: 'employee/widget',
    container: 'user',
    skeleton: UserInfoSkeleton,
    order: 1,
    size_large: {
      x: 12,
      y: 214,
    },
    size_medium: {
      x: 12,
      y: 214,
    },
    size_small: {
      x: 12,
      y: 214,
    },
    href: null,
    link: null,
    email: 'Help_LKE@beeline.ru',
  },
  {
    name: 'department/widget',
    host: APP_LK_EMPLOYEE_HOST,
    container: 'departament',
    skeleton: DepartmentSkeleton,
    link: null,
    href: null,
    size_large: {
      x: 12,
      y: 214,
    },
    size_medium: {
      x: 12,
      y: 214,
    },
    size_small: {
      x: 12,
      y: 214,
    },
    order: 2,
    id: 2,
    email: 'Help_LKE@beeline.ru',
  },
  {
    name: 'survey/widget',
    host: APP_LK_EMPLOYEE_HOST,
    container: 'banners',
    skeleton: BannersSkeleton,
    link: '',
    href: null,
    size_large: {
      x: 12,
      y: 150,
    },
    size_medium: {
      x: 12,
      y: 150,
    },
    size_small: {
      x: 12,
      y: 150,
    },
    order: 3,
    id: 3,
    email: 'Help_LKE@beeline.ru',
  },
  ...developData,
  ...testOnlyWidgets,
];
